import React from 'react';
import { compose, hoistStatics, lifecycle, withHandlers, withState, withPropsOnChange } from 'recompose';
import { translate } from 'react-i18next';
import { Emoji } from 'emoji-mart';
import ReactDOMServer from 'react-dom/server';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import getErrorMessage from '../../../components/validation/errorMessages';
import AddNew from './AddNew';
import { uploadActions } from '../../../reducers/upload';

import fh from '../../../helpers/form.helper';

const openEmoji = ({ setShowEmo, showEmo }) => (e) => {
  setShowEmo(!showEmo);
};

const openGifs = ({ setShowGif, showGif }) => (e) => {
  setShowGif(!showGif);
};

const removeBr = data => (data ? data.replace(/<br class="temp">/g, '') : data);

const addEmoji = props => (e) => {
  document.querySelector('.msg-input').focus();
  const newEmoji = Emoji({
    emoji: e.colons,
    size: 20,
  });
  const newStyle = newEmoji.props.children.props.style;
  const newImg = ReactDOMServer.renderToString(<img
    src={newStyle.backgroundImage.slice(4, -1)}
    className="emoji-input"
    style={{
      objectPosition: '-99999px 99999px',
      height: newStyle.height,
      width: newStyle.width,
      backgroundImage: newStyle.backgroundImage,
      backgroundPosition: newStyle.backgroundPosition,
      backgroundSize: newStyle.backgroundSize,
      verticalAlign: 'bottom',
    }}
  />);
  fh.getCaretPosition(newImg);
  props.setNewComment(document.querySelector('.msg-input').innerHTML);
};

const changeText = props => (evt) => {
  const { value } = evt.target;
  const newData = removeBr(value);
  props.setNewComment(`${newData}<br class="temp">`);
};

const sendGif = props => async (e, url) => {
  e.preventDefault();
  const { onSubmit, setShowGif } = props;
  setShowGif(false);
  await onSubmit(e, {
    message: `<img src=${url} width="100%"/>` });
};

const preSubmit = props => async (e) => {
  const {
    setIsSubmitting,
    isSubmitting,
    onSubmit,
    newComment,
    isEditing,
    setNewComment,
    upload_name,
    mulTempFiles,
    setErrorMessage,
    submitDefault,
    setIsEditing,
    removeMulTempFilesById,
    t,
  } = props;
  if (!isSubmitting) {
    setIsSubmitting(true);
    e.preventDefault();
    const files = mulTempFiles[upload_name] && mulTempFiles[upload_name].length ?
      mulTempFiles[upload_name].map(ticket => ticket.id) : [];
    let resp = {};
    if (!isEditing) {
      resp = await onSubmit(e, {
        message: removeBr(newComment),
        files });
    } else {
      resp = await submitDefault(e, {
        message: removeBr(newComment),
        files });
    }
    if (!resp.errors) {
      setNewComment('');
      removeMulTempFilesById(upload_name);
      setErrorMessage('');
    } else {
      setErrorMessage(getErrorMessage(
        t,
        resp.errors.message.validation,
        resp.errors.message.message,
      ) || '');
    }
    setIsEditing(false);
    setIsSubmitting(false);
  }
};

const cancelEdit = props => async (e) => {
  const {
    setNewComment,
    upload_name,
    removeMulTempFilesById,
    setIsEditing,
    setMessageToEdit,
  } = props;

  e.preventDefault();
  setMessageToEdit(null);
  setIsEditing(false);
  setNewComment('');
  removeMulTempFilesById(upload_name);
};

const onKeyPress = props => async (e) => {
  if (e.key === 'Enter' && !e.shiftKey) {
    preSubmit(props)(e);
  }
};

const onChange = props => (e) => {
  const { setNewComment } = props;
  setNewComment(e.target.value);
};

const editText = (props) => {
  const { setNewComment, defaultValue, setIsEditing } = props;
  setNewComment(defaultValue.content);
  setIsEditing(true);
};

const mapStateToProps = state => ({
  mulTempFiles: state.upload.mulTempFiles,
});

const mapDispatchToProps = {
  removeMulTempFilesById: uploadActions.removeMulTempFiles,
};

const handleClickOutside = props => (event) => {
  const emojiWrapper = document.querySelector('#emo');
  const gifWrapper = document.querySelector('#gif');
  if ((emojiWrapper && event.target !== emojiWrapper && !emojiWrapper.contains(event.target))
    || (gifWrapper && event.target !== gifWrapper && !gifWrapper.contains(event.target))) {
    const { setShowEmo, setShowGif } = props;
    setShowEmo(false);
    setShowGif(false);
  }
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withState('newComment', 'setNewComment', ''),
  withState('isSubmitting', 'setIsSubmitting', false),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('showEmo', 'setShowEmo', false),
  withState('showGif', 'setShowGif', false),
  withState('isEditing', 'setIsEditing', false),
  lifecycle({
    async componentDidMount() {
      document.addEventListener('mousedown', handleClickOutside(this.props));
    },
    componentWillUnmount() {
      document.removeEventListener('mousedown', handleClickOutside);
    },
  }),
  withPropsOnChange(['defaultValue'], (props) => {
    if (props.defaultValue) {
      editText(props);
    }
  }),
  withHandlers({
    onKeyPress,
    onChange,
    preSubmit,
    openEmoji,
    addEmoji,
    changeText,
    cancelEdit,
    openGifs,
    sendGif,
  }),
);

export default withRouter(hoistStatics(enhance)(AddNew));



// WEBPACK FOOTER //
// ./src/components/comments/addNew/index.js